const ANALYTICS_ID = "G-HM4WB14NFJ";
const ANALYTICS_SCRIPT_ID = "dr-hoffmann-google-tag";
const CONSENT_STORAGE_KEY = "dr_hoffmann_cookie_consent";

export const COOKIE_CONSENT = {
  accepted: "accepted",
  declined: "declined",
};

export function getCookieConsentDecision() {
  try {
    return window.sessionStorage.getItem(CONSENT_STORAGE_KEY);
  } catch {
    return null;
  }
}

function storeCookieConsentDecision(decision) {
  try {
    window.sessionStorage.setItem(CONSENT_STORAGE_KEY, decision);
  } catch {
    /* ignore storage restrictions */
  }
}

function configureGoogleTag() {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (window.__drHoffmannAnalyticsConfigured) return;

  window[`ga-disable-${ANALYTICS_ID}`] = false;
  window.gtag("js", new Date());
  window.gtag("config", ANALYTICS_ID, { send_page_view: false });
  window.__drHoffmannAnalyticsConfigured = true;
}

export function loadAnalyticsAfterConsent() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  configureGoogleTag();

  if (document.getElementById(ANALYTICS_SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = ANALYTICS_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_ID}`;
  document.head.appendChild(script);
}

export function acceptAnalyticsCookies() {
  storeCookieConsentDecision(COOKIE_CONSENT.accepted);
  loadAnalyticsAfterConsent();
  window.dispatchEvent(new Event("dr-hoffmann-cookie-consent-change"));
}

export function declineAnalyticsCookies() {
  storeCookieConsentDecision(COOKIE_CONSENT.declined);
  window[`ga-disable-${ANALYTICS_ID}`] = true;
  window.dispatchEvent(new Event("dr-hoffmann-cookie-consent-change"));
}

export function isAnalyticsConsentGranted() {
  return getCookieConsentDecision() === COOKIE_CONSENT.accepted;
}
